module.exports = __webpack_public_path__ + "static/img/049 1.2b872391.jpg";